import {
  Component,
  OnInit,
  Injector,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { JoditAngularComponent } from 'jodit-angular';
import { Editor } from 'ngx-editor';

@Component({
  selector: 'app-variable-pay-letter-popup',
  templateUrl: './variable-pay-letter-popup.component.html',
  styleUrls: ['./variable-pay-letter-popup.component.scss'],
})
export class VariablePayLetterPopupComponent implements OnInit {
  @ViewChild('joditEditor') joditEditor!: JoditAngularComponent;

  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInUserCompanyID: any;
  vpletterContent: string = '';
  vpPolicyUrlSubject: any;
  selectedYearForLetterHead: any;
  frequencyPeriod: any;
  checkVPSubject: boolean = false;
  checkVPContent: boolean = false;
  popupName: string = 'Create Email Body';
  letterDatafromBackend: any;
  editor: any;
  isEditEmail: boolean = false;

  editorConfig: any = {
    height: 430,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_html',
    language: 'en',
    i18n: {
      en: {
        'Paste as HTML': 'Paste',
        'Your code is similar to HTML. Keep as HTML?':
          'Do you want to keep this content as it is?',
      },
    },
    uploader: {
      insertImageAsBase64URI: true,
    },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'left', 'center', 'right', 'justify', '|',
      'preview', '|',
      'undo', 'redo', '|',
      'fontsize', 'link',
    ],
  };

  constructor(
    public dialog: MatDialog,
    private encryptionService: EncryptionService,
    private config: Config,
    private httpService: HttpService,
    public router: Router,
    private injector: Injector,
    private cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<VariablePayLetterPopupComponent>
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserCompanyID = Number(
      this.encryptionService.decryptData(
        sessionStorage.getItem('loggedInUserCompanyID')
      )
    );

    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(
        this.loggedInUserRole
      );
    }

    this.loggedInUserRoles = JSON.parse(
      sessionStorage.getItem('loggedInUserRoles') || '[]'
    );

    const dialogData = this.injector.get(MAT_DIALOG_DATA);
    this.selectedYearForLetterHead = dialogData?.frequency;
    this.frequencyPeriod = dialogData?.year;

    this.getVPPolicyFile();
  }

 /** Called when editor content changes */
  onEditorChange(event: any) {
  // Jodit passes an object like { value: '<html>' }
  if (event && event.value !== undefined) {
    this.vpletterContent = event.value;
  } else if (typeof event === 'string') {
    this.vpletterContent = event;
  }
}


  /** Fetch existing letter data from backend */
  getVPPolicyFile() {
    const test = this.selectedYearForLetterHead.split('-');
    const request = {
      companyId: this.loggedInUserCompanyID,
      frequencyCycle: this.frequencyPeriod,
      fromYear: test[0],
      relatedToName: 'VP Letter',
      toYear: test[1],
      isShowLetterLink: false,
    };

    this.httpService
      .callPostService(this.config.getVPPolicyFile, request)
      .subscribe((result: any) => {
        if (result?.data != null) {
          this.letterDatafromBackend = result.data;
          this.vpPolicyUrlSubject = result.data?.vpPolicyUrlSubject;
          this.vpletterContent = result.data?.vpPolicyFileNameBody || '';
        } else {
          // Default template if no backend data
          this.vpletterContent = `Dear [Employee Name],
          <div><br></div>
          <div>We are happy to announce that you are eligible for <b>Variable Pay (VP)</b> as a recognition of your contributions and dedication.</div>
          <div><br></div>
          <div>To view your VP letter, please follow these steps:</div>
          <div>1) Click on the PHI HRIS login link: [Login Link]</div>
          <div>2) Enter your credentials</div>
          <div>3) Navigate to the VP Module</div>
          <div>4) Your VP letter is available there for reference.</div>
          <div><br></div>
          <div>Best regards,<br/>[HR Name],<br/>[Company Name]</div>`;
        }

        // 👇 Make sure Angular detects and updates Jodit
        this.cd.detectChanges();

        // 👇 Force sync with editor after DOM update
        setTimeout(() => {
          if (this.joditEditor) {
            this.joditEditor.value = this.vpletterContent;
          }
        }, 150);
      });
  }

  /** Save updated email body */
  saveVPPolicyFile() {
    if (this.vpletterContent && this.vpPolicyUrlSubject) {
      this.checkVPSubject = false;
      this.checkVPContent = false;
      const test = this.selectedYearForLetterHead.split('-');

      const request = {
        companyId: this.loggedInUserCompanyID,
        frequencyCycle: this.frequencyPeriod,
        fromYear: test[0],
        isDeleted: false,
        relatedToName: 'VP Letter',
        toYear: test[1],
        vpPolicyFileNameBody: this.vpletterContent,
        vpPolicyUrlSubject: this.vpPolicyUrlSubject,
      };

      this.httpService
        .callPostService(this.config.saveVPPolicyFile, request)
        .subscribe((result: any) => {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: result?.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false,
            },
          });
          successdialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        });
    } else {
      this.checkVPSubject = !this.vpPolicyUrlSubject;
      this.checkVPContent = !this.vpletterContent;
    }
  }

  /** Discard changes */
  onClickDiscardChanges() {
    this.checkVPSubject = false;
    this.checkVPContent = false;
    this.dialogRef.close();
  }
}
